/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmailMatchRule } from './EmailMatchRule';
import {
    EmailMatchRuleFromJSON,
    EmailMatchRuleFromJSONTyped,
    EmailMatchRuleToJSON,
    EmailMatchRuleToJSONTyped,
} from './EmailMatchRule';

/**
 * 
 * @export
 * @interface CreateEmailMatchRuleResponse
 */
export interface CreateEmailMatchRuleResponse {
    /**
     * 
     * @type {EmailMatchRule}
     * @memberof CreateEmailMatchRuleResponse
     */
    rule: EmailMatchRule;
}

/**
 * Check if a given object implements the CreateEmailMatchRuleResponse interface.
 */
export function instanceOfCreateEmailMatchRuleResponse(value: object): value is CreateEmailMatchRuleResponse {
    if (!('rule' in value) || value['rule'] === undefined) return false;
    return true;
}

export function CreateEmailMatchRuleResponseFromJSON(json: any): CreateEmailMatchRuleResponse {
    return CreateEmailMatchRuleResponseFromJSONTyped(json, false);
}

export function CreateEmailMatchRuleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEmailMatchRuleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rule': EmailMatchRuleFromJSON(json['rule']),
    };
}

export function CreateEmailMatchRuleResponseToJSON(json: any): CreateEmailMatchRuleResponse {
    return CreateEmailMatchRuleResponseToJSONTyped(json, false);
}

export function CreateEmailMatchRuleResponseToJSONTyped(value?: CreateEmailMatchRuleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rule': EmailMatchRuleToJSON(value['rule']),
    };
}

